import { css } from 'lit';

export const style = css`
  [hidden] {
    display: none;
  }

  .personal__city {
    margin-bottom: -1rem;
  }

  .address-ndi {
    margin-top: 1rem;
  }

  @media (min-width: 542px) {
    .personal_compact-address {
      display: grid;
      gap: 1rem;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 1rem;
    }

    .personal_compact-address > .personal__address_street {
      margin-bottom: -1rem;
    }

    .personal_compact-address > .personal__address_apt {
      margin-bottom: -1rem;
    }

    .personal_compact-address > .personal__address_state {
      margin-bottom: -1rem;
    }

    .personal_compact-address > .personal__address_zip {
      margin-bottom: -1rem;
    }
  }
`;
